import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for SegmentVersion entity operations.
 * F-017: Saved Selection Segments - Version history access.
 */
@Injectable({
    providedIn: 'root'
})
export class SegmentVersionService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/segmentVersions')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-code-branch';
    }
}
